import React from "react";
import { Box } from "@chakra-ui/react";

export default function WartungsprotokollSeite11b({ form, setForm }) {


  if (!form || !form.abschluss || !form.anmerkungen) return null;


  const toggleAbschluss = (index) => {
    const copy = [...form.abschluss];
    copy[index] = !copy[index];
    setForm(prev => ({ ...prev, abschluss: copy }));
  };

  const updateAnmerkung = (index, value) => {
    const copy = [...form.anmerkungen];
    copy[index] = value;
    setForm(prev => ({ ...prev, anmerkungen: copy }));
  };

  const lines = [
    "Alle WR sind in Betrieb und speisen ein",
    "Anlage und Gebäude geschlossen",
    "Unterlagen, Wartungsmappe und Schlüssel zurückgegeben",
    "Messgeräte funktionsfähig",
    "Dokumentationsbilder und Messprotokoll abgelegt",
    "Beiblätter vorhanden"
  ];

  return (
    <Box p={8} bg="white" borderRadius="xl" boxShadow="md" mt={3} mb={3}>
    <div className="p-6 text-sm">


      <table className="w-full mb-6 text-xs" style={{ borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "70%" }}>
              Abschluss der Arbeiten
            </th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>
              Ja
            </th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "25%" }}>
              Anmerkung
            </th>
          </tr>
        </thead>

        <tbody>
          {lines.map((label, i) => (
            <tr key={i}>
              {/* Text column */}
              <td style={{ border: "1px solid #ccc", padding: "4px" }}>
                {label}
              </td>

              {/* Ja checkbox */}
              <td
                style={{
                  border: "1px solid #ccc",
                  textAlign: "center",
                  padding: "4px",
                }}
              >
                <input
                  type="checkbox"
                  checked={form.abschluss[i]}
                  onChange={() => toggleAbschluss(i)}
                />
              </td>

              {/* Anmerkung input line */}
              <td style={{ border: "1px solid #ccc", padding: "0" }}>
                <input
                  type="text"
                  value={form.anmerkungen[i] || ""}
                  onChange={(e) => updateAnmerkung(i, e.target.value)}
                  style={{
                    width: "100%",
                    height: "28px",
                    border: "none",
                    backgroundColor: "#f7f7fb",
                    padding: "4px",
                  }}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Bottom confirmation */}
       <Box p={4} borderWidth="1px" borderRadius="md" mt={3} mb={3} maxW="400px">
      <div className="grid grid-cols-2 mt-10 text-xs" style={{ columnGap: "40px" }}>
        <span className="pr-6">
          Alle Arbeiten erledigt und dokumentiert, Protokoll vollständig ausgefüllt {"  "}
        </span>

          
        <input
          type="checkbox"
          checked={form.allesErledigt}
          onChange={() =>
            setForm(prev => ({ ...prev, allesErledigt: !prev.allesErledigt }))
          }
        />
      </div>
      </Box>

      {/* Date + signature */}
      {/* Date + signature */}
      <div className="grid grid-cols-2 mt-10 text-xs" style={{ columnGap: "40px" }}>
        <div>
          <label className="block mb-4">Datum { "  " } </label>
          <input
            value={form.datum}
            onChange={e => setForm(prev => ({ ...prev, datum: e.target.value }))}
             className="w-full p-1 bg-gray-100 border-2 border-gray-500 rounded"
          />
        </div>

        <div>
          <label className="block mb-4">
            Die Unterschrift der verantwortlichen Elektrofachkraft kann nach dem Erstellen des PDFs entweder digital oder handschriftlich hinzugefügt werden.
          </label>
        </div>
      </div>

    </div>
    </Box>
  );
}
